import { render, staticRenderFns } from "./DailyCountChart.vue?vue&type=template&id=01570204&lang=pug"
import script from "./DailyCountChart.vue?vue&type=script&lang=ts"
export * from "./DailyCountChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports